import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { GroupHeader } from '@clds/menu';

export const StrictTransformationsWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  div {
    font-weight: initial;
  }
`;

export const StyledGroupHeader = styled(GroupHeader)`
  pointer-events: none;
  padding-top: ${globalTheme.spacing.md};
`;

export const StyledLink = styled.a`
  display: flex;
  justify-content: start;
  align-items: center;
  padding-left: ${globalTheme.font.size.xxs};
  height: ${globalTheme.font.size.xl};
  font-size: ${globalTheme.font.size.xxs};
`;
